export default __webpack_public_path__ + "static/0165-9bcd8e2239a2dae08792b658070b15b4.png";